import {serverApi} from '../../api/serverAPI'
const datas = {


loginAsCustomer: (username) => new Promise((resolve, reject) => {
  serverApi.post('/auth/login-as', username)
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
}),
getActions: (email) => new Promise((resolve, reject) => {
  console.log(email)
  serverApi.get('/mailchimp/members/activity/1',{params:email})
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
}),
getMailchimpProfile: (email) => new Promise((resolve, reject) => {
  console.log(email)
  serverApi.get('/mailchimp/members/member/profile',{params:email})
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
}),
createManualCert:(cert)=> new Promise((resolve, reject) => {
  console.log(cert)
  serverApi.post('/certificates/createManualCert',cert)
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })

})
}
export default datas


// WEBPACK FOOTER //
// ./src/components/Customers/api.js